import React, { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { DEFAULT_PAGE_LENGTH } from '../../utils/app-constants';
import { decryptAEStoJSON, toastEmitter } from '../../utils/utilities';
import { useSelector } from 'react-redux';
import TableLayout from '../../components/layouts/table-layout';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { getDoctorInvoiceDownload, getDoctorInvoiceList } from '../../hooks/services/api-services';
import Modal from '../../components/common/Model';
import { API_URL } from '../../utils/url-constants';
import { toWords } from 'number-to-words';


const DoctorInvoice = () => {
  const { t, i18n } = useTranslation();
  const [pending, setPending] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_LENGTH);
  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [totalRows, setTotalRows] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [isMonthSelected, setIsMonthSelected] = useState(false);
  const [doctorInvoiceModal, setDoctorInvoiceModal] = useState(false);
  const [doctorModal, setDoctormodal] = useState({});
  const ViewModel = useRef(null);
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);

  const fetchDoctorInvoiceData = async (monthYear) => {
    try {
      setPending(true);
      setIsMonthSelected(true);

      const requestPayload = {
        pageIndex: page,
        pageSize: pageSize,
        clinicId: userData?.id,
        searchText: '',
        direction: sortDirection || 'desc',
        filterByFieldName: sortColumn || 'id',
        monthYear: monthYear || null,
        userType: "CLINIC",
        languageType: i18n.language
      };

      const response = await getDoctorInvoiceList(requestPayload);

      if (response?.data?.status === 200) {
        const doctorList = response.data.data.doctorTransactionSummaryResponseList || [];
        setRowData(doctorList);
        setTotalRows(response.data.data.totalElement || 0);
        setTotalPayment(response.data.data.total || 0);
      } else {
        setRowData([]);
      }
    } catch (error) {
      console.error('Invoice data fetch failed:', error);
      setRowData([]);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    if (isMonthSelected && selectedMonth) {
      fetchDoctorInvoiceData(moment(selectedMonth).format('YYYY-MM'));
    }
  }, [page, pageSize, sortColumn, sortDirection, i18n.language]);

  // useEffect(() => {
  //   if (selectedMonth) {
  //     fetchDoctorInvoiceData(moment(selectedMonth).format('YYYY-MM'));
  //   } else {
  //     fetchDoctorInvoiceData(null);
  //   }
  // }, [page, pageSize, sortColumn, sortDirection, i18n.language]);

  const metaData = [
    { name: "Account Summary", url: null },
    { name: "Assesment Generate", url: null },
  ];

  const tableColumns = [
    {
      name: t('S.No'),
      width: '80px',
      selector: (row, index) => `${page * pageSize + index + 1}`,
    },
    {
      name: t('Doctor Name'),
      selector: (row) => row.doctorName,
      sortable: true,
      width: '160px',
      cell: (row) => <div className="fw-500 fs-12">{row.doctorName}</div>,
    },
    {
      name: t('Booking Amount'),
      selector: (row) => row.bookingPrice,
      sortable: true,
      width: '160px',
      cell: (row) => <div className="fw-500 fs-12">{row.bookingPrice}</div>,
    },
    {
      name: t('Appointment Session'),
      selector: (row) => row.quantity,
      sortable: true,
      width: '200px',
      cell: (row) => <div>{row.quantity}</div>,
    },
    {
      name: t('Admin Fee'),
      selector: (row) => row.adminShare,
      sortable: true,
      width: '140px',
      cell: (row) => <div>{row.adminShare}</div>,
    },
    {
      name: t('Clinic Fee'),
      selector: (row) => row.clinicShare,
      sortable: true,
      width: '140px',
      cell: (row) => <div>{row.clinicShare}</div>,
    },
    {
      name: t('Doctor Fee'),
      selector: (row) => row.doctorShare,
      sortable: true,
      width: '140px',
      cell: (row) => <div>{row.doctorShare}</div>,
    },

    {
      name: t("Action"),
      width: "200px",
      compact: true,
      cell: (row) => (
        <div>
          <div
            className="row-actions d-flex align-items-center"
          >
            {row?.status === 0 ? (
              <button
                type="button"
                className="btn btn-primary fs-12"
                onClick={() => handleInvoice(row)}
              >
                Generate Invoice
              </button>
            ) : (
              <div className="row-actions d-flex align-items-center ">
                <button
                  className="btn btn-primary fs-12"
                  onClick={() => {
                    // setDoctormodal(row);
                    handleDownloadAssesmentinvoice(row);
                  }}
                >
                  {" "}
                  {downloadInvoiceLoading && (
                    <i className="fa fa-spinner fa-spin mr-2"></i>
                  )}{" "}
                  Download
                </button>
              </div>
            )}
          </div>
        </div>
      ),
    },
  ];

  const handleInvoice = (row) => {
    setDoctormodal(row);
    ViewModel?.current?.click();
  }
  // Download Invoice
  const [downloadInvoiceLoading, setDownloadInvoiceLoading] = useState(false);
  const [downloadInvoice, setDownloadInvoice] = useState();
  const handleDownloadAssesmentinvoice = async (row) => {
    const payload = {
      doctorId: row?.doctorId,
      clinicId: userData?.id,
      month: moment(selectedMonth).format("YYYY-MM"),
      status: 1,
      userType: "CLINIC",
      languageType: i18n.language
    };

    try {
      const response = await getDoctorInvoiceDownload(payload); // Your API function

      if (response?.data?.status === 200) {
        toastEmitter("success", response?.data?.message);
        const fileUrl = response?.data?.data?.fileUrl;
        if (fileUrl) {
          // Open file in new tab
          const fullUrl = `${API_URL?.ServerURL}${fileUrl}`;
          window.open(fullUrl, "_blank");
        } else {
          toastEmitter("error", "File URL not found in response.");
        }

        // Optionally refresh table
        fetchDoctorInvoiceData(moment(selectedMonth).format("YYYY-MM"));
      } else {
        toastEmitter("error", response?.data?.message || "Something went wrong.");
      }
    } catch (err) {
      toastEmitter("error", "Server Error");
    }

  };

  const handlegenerateinvoiceById = async (id) => {
    try {
      const payload = {
        doctorId: doctorModal?.doctorId,
        clinicId: userData?.id,
        month: moment(selectedMonth).format("YYYY-MM"),
        status: 1,
        userType: "CLINIC",
        languageType: i18n.language
      };

      const response = await getDoctorInvoiceDownload(payload);
      if (response.status === 200) {
        toastEmitter("success", response.data.message);
        ViewModel?.current?.click();
        // Optional: Update rowData to reflect the newly downloaded invoice
        const updatedData = rowData.map(item => {
          if (item.id === doctorModal?.id) {
            return {
              ...item,
              status: 1,
              invoicePath: response.data?.data?.fileUrl || ""
            };
          }
          return item;
        });
        setRowData(updatedData);

        setDoctorInvoiceModal(false);
      } else {
        toastEmitter("error", response.data.message);
      }
    } catch (err) {
      toastEmitter("error", "Something went wrong.");
    }
  };
  // const totalAmountNumber = Number(doctorModal?.totalAmount) || 0;
  // const totalInWords = toWords(totalAmountNumber);

  // Calculate VAT from taxable amount
  // const vatAmount = doctorModal?.taxableAmount
  //   ? (Number(doctorModal.taxableAmount) * 18) / 100
  //   : 0;

  const taxableAmount = Number(doctorModal?.taxableAmount || 0);
  const totalAmountNumber = taxableAmount;
  const totalInWords = toWords(Math.round(totalAmountNumber));

  return (
    <div>
      <div className="flex-wrap d-flex justify-content-between align-items-center mb-3">
        <div className="fw-bold fs-5">{t('Doctor Invoice')}</div>
        <div className="flex-wrap d-flex gap-2 align-items-center">
          <label className="fw-bold mb-0">{t('Select Month')}:</label>
          <div className="position-relative">
            {/* <input
              type="month"
              className="form-control "
              // value={moment(selectedMonth).format("YYYY-MM")}
              value={selectedMonth ? moment(selectedMonth).format("YYYY-MM") : ""}
              onChange={(e) => {
                const date = moment(e.target.value, "YYYY-MM").toDate();
                setSelectedMonth(date);
                fetchDoctorInvoiceData(moment(date).format("YYYY-MM"));
              }}
              placeholder={t("Select Month")}
            /> */}
            <input
              type="month"
              className="form-control cursor-pointer"
              value={selectedMonth ? moment(selectedMonth).format("YYYY-MM") : ""}
              onChange={(e) => {
                if (!e.target.value) {
                  setSelectedMonth(null);
                  fetchDoctorInvoiceData(null);
                  return;
                }

                const date = moment(e.target.value, "YYYY-MM").toDate();
                setSelectedMonth(date);
                fetchDoctorInvoiceData(moment(date).format("YYYY-MM"));
              }}
            />

          </div>
        </div>
      </div>

      <div className="table-wrapper">
        <TableLayout
          _tblColumns={tableColumns}
          _rowData={rowData}
          pending={pending}
          pagination={true}
          selectableRows={false}
          setPending={setPending}
          _totalRows={totalRows}
          pageSize={pageSize}
          setPageSize={setPageSize}
          setPage={setPage}
          setSortColumn={setSortColumn}
          setSortDirection={setSortDirection}
        />
      </div>

      <Modal
        closebtnclass="closebtnclass"
        modalId="DoctorInvoice"
        modalClick={ViewModel}
        className="modal-xl"
        modalContentClass=""
      >
        <title>Tax Invoice</title>
        <div
          style={{
            width: '1000px',
            margin: '0 auto',
            fontFamily: 'Arial, sans-serif',
            padding: 0,
            fontSize: '14px',
          }}
        >
          <div style={{ padding: '30px', border: '1px solid #ddd' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <tbody>
                <tr>
                  <td colSpan="2" style={{ textAlign: 'start', paddingBottom: '20px' }}>
                    <img
                      src="https://innovierhealth.com//doctorandpatient/7f8ccab1-692c-4bd2-b5ba-a0cd71e98f08.png"
                      alt="medicine Logo"
                      style={{ maxWidth: '150px', height: 'auto' }}
                    />
                  </td>
                  <td colSpan="2" style={{ textAlign: 'right' }}>
                    <h1 style={{ margin: 0, fontSize: '24px' }}>INVOICE</h1>
                  </td>
                </tr>

                <tr>
                  <td><h4 style={{ color: '#242424', margin: 0, textAlign: "left" }}>Billed By</h4></td>
                  <td><h4 style={{ color: '#242424', margin: 0, textAlign: "left" }}>Billed To</h4></td>
                  <td style={{ textAlign: 'right' }}>
                    <p style={{ margin: 0 }}>
                      <strong>Invoice No: MED-202425350</strong>
                    </p>
                  </td>
                </tr>

                <tr>
                  <td><p style={{ margin: '10px 0', textAlign: "left" }}>{doctorModal?.clinicResponse?.clinicName}</p></td>
                  <td><p style={{ margin: '10px 0', textAlign: "left" }}>{doctorModal?.doctorName}</p></td>
                  <td style={{ textAlign: 'right' }}>
                    <p style={{ margin: 0 }}>
                      <strong> Invoice Date: 30-06-2025</strong>
                    </p>
                  </td>
                </tr>

                <tr>
                  <td>
                    <p style={{ margin: '10px 0', textAlign: "left" }}>
                      {doctorModal?.clinicResponse?.address}
                    </p>
                  </td>
                  <td><p style={{ margin: 0, textAlign: "left" }}>{doctorModal?.address}</p></td>
                  <td style={{ textAlign: 'right' }}>
                    <p style={{ margin: '10px 0' }}>
                      <strong> Place of Supply: Paris(06)</strong>
                    </p>
                  </td>
                </tr>



                <tr>
                  <td><p style={{ margin: '10px 0', textAlign: "left" }}><strong>Email</strong>: {doctorModal?.clinicResponse?.email}</p></td>
                  <td><p style={{ margin: '10px 0', textAlign: "left" }}><strong>Email</strong>: {doctorModal?.email}</p></td>

                </tr>

                <tr>
                  <td><p style={{ margin: '10px 0', textAlign: "left" }}><strong>Phone</strong>: {`${doctorModal?.clinicResponse?.code} ${doctorModal?.clinicResponse?.mobileNo}`}</p></td>
                  <td><p style={{ margin: '10px 0', textAlign: "left" }}><strong>Phone</strong>: {`${doctorModal?.code} ${doctorModal?.mobileNo}`}</p></td>


                </tr>

                {/* Item Table */}
                <tr>
                  <td colSpan="4" style={{ padding: '10px 0' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd' }}>
                      <tbody>
                        <tr>
                          {['Item', 'Appointment Session', 'Booking Amount', 'Total Amount'].map((head) => (
                            <th key={head} style={cellStyle}>{head}</th>
                          ))}
                        </tr>
                        <tr>
                          <td style={cellStyle}>Consultation Revenue</td>
                          <td style={cellStyle}>{doctorModal?.quantity}</td>
                          <td style={cellStyle}>{doctorModal?.bookingPrice}</td>
                          <td style={cellStyle}>{taxableAmount.toFixed(2)}</td>
                        </tr>
                        {/* Total Row */}
                        <tr>
                          {/* First column blank */}
                          <td style={{ border: "none" }}></td>

                          {/* Second column blank */}
                          <td style={{ border: "none" }}></td>

                          {/* Third column (Booking Amount column ke niche) */}
                          <td
                            style={{
                              borderTop: "1px solid #ddd",
                              borderBottom: "1px solid #ddd",
                              borderLeft: "1px solid #ddd",
                              borderRight: "none",
                              padding: "8px",
                              textAlign: "center"
                            }}
                          >
                            Admin Fee                          </td>

                          {/* Fourth column (Amount column) */}
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "8px",
                              textAlign: "center"
                            }}
                          >
                            {doctorModal?.adminShare?.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          {/* First column blank */}
                          <td style={{ border: "none" }}></td>

                          {/* Second column blank */}
                          <td style={{ border: "none" }}></td>

                          {/* Third column (Booking Amount column ke niche) */}
                          <td
                            style={{
                              borderTop: "1px solid #ddd",
                              borderBottom: "1px solid #ddd",
                              borderLeft: "1px solid #ddd",
                              borderRight: "none",
                              padding: "8px",
                              textAlign: "center"
                            }}
                          >
                            Clinic Fee
                          </td>

                          {/* Fourth column (Amount column) */}
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "8px",
                              textAlign: "center"
                            }}
                          >
                            {doctorModal?.clinicShare?.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          {/* First column blank */}
                          <td style={{ border: "none" }}></td>

                          {/* Second column blank */}
                          <td style={{ border: "none" }}></td>

                          {/* Third column (Booking Amount column ke niche) */}
                          <td
                            style={{
                              borderTop: "1px solid #ddd",
                              borderBottom: "1px solid #ddd",
                              borderLeft: "1px solid #ddd",
                              borderRight: "none",
                              padding: "8px",
                              textAlign: "center"
                            }}
                          >
                            <strong>Total (USD)</strong>
                          </td>

                          {/* Fourth column (Amount column) */}
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "8px",
                              textAlign: "center"
                            }}
                          >
                            <strong>{taxableAmount.toFixed(2)}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>

                {/* Amount Totals */}

                <tr>
                  <td colspan='4' style={{ border: "1px solid #ccc", padding: "6px", textAlign: "right" }}>
                    <strong>Total In Words:</strong> {totalInWords.charAt(0).toUpperCase() + totalInWords.slice(1)} Only

                  </td>
                </tr>

                <tr><td colspan='4' style={{ height: "25px" }}></td></tr>


                {/* Bank Details */}
                {/* <tr><td colSpan="4"><h4 style={{ color: '#242424', margin: 0, textAlign: "left" }}>Bank Details</h4></td></tr>
                <tr><td colSpan="4"><p style={{ margin: '5px 0', textAlign: "left" }}>Account Holder Name: {doctorModal.clinicResponse?.clinicName}</p></td></tr>
                <tr><td colSpan="4"><p style={{ margin: '5px 0', textAlign: "left" }}>IBAN Number: {doctorModal?.clinicResponse?.bankDetailsResponseList?.iban}</p></td></tr>
                <tr><td colSpan="4"><p style={{ margin: '5px 0', textAlign: "left" }}>SwiftBicCode:{doctorModal?.clinicResponse?.bankDetailsResponseList?.swiftBicCode} </p></td></tr>
                <tr><td colSpan="4"><p style={{ margin: '5px 0', textAlign: "left" }}>Bank: {doctorModal?.clinicResponse?.bankDetailsResponseList?.bankName}</p></td></tr>
                <tr><td colSpan="4"><p style={{ margin: '5px 0', textAlign: "left" }}>Branch:{doctorModal?.clinicResponse?.bankDetailsResponseList?.branchName} </p></td></tr> */}

                {/* Footer */}
                <tr >
                  <td colSpan="4" style={{
                    border: '2px solid black',
                    padding: '10px',
                    textAlign: 'center',
                    margin: '20px',

                  }}>
               
                      For any enquiry, reach out via email at accounts <b>info@innovierhealth.com</b>  or call on      <b>+48 692 075 566</b>

                    
                  </td>
                </tr>
                <tr>
                  <td colSpan="4" style={{ padding: '5px 0', textAlign: 'center' }}>
                    <small>This is an electronically generated document, no signature is required.</small>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <tr>

            <td >
              <button
                type="button"
                style={{
                  padding: "5px 10px",
                  backgroundColor: "red",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                  margin: "20px 0 30px",
                  textAlign: "right"
                }}
                onClick={() =>
                  handlegenerateinvoiceById(doctorModal.id)
                }
              >
                Generate
              </button>
            </td>
          </tr>
        </div>

      </Modal>

    </div>
  );
};
const cellStyle = {
  border: '1px solid #ddd',
  padding: '8px',
  textAlign: 'center',
};
export default DoctorInvoice;